import { render, staticRenderFns } from "./references.vue?vue&type=template&id=dc5968d6&scoped=true&"
import script from "./references.vue?vue&type=script&lang=js&"
export * from "./references.vue?vue&type=script&lang=js&"
import style0 from "./references.vue?vue&type=style&index=0&id=dc5968d6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5968d6",
  null
  
)

export default component.exports